import React from 'react';
import cx from 'classnames'
import './styles.scss'

const ErrorMessage = ({ errorText }) => {
  return (
    <div className="mobile-application-invalid-feedbacks">
      <div>{errorText}</div>
    </div>
  )
}

const Input = ({ value, handleChange, name, hasError, errorText, touched, placeholder, id, tabindex }) => {
  return (
    <>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        name={name}
        className={cx("form-control", "mobile-application-input", {
          "input-error":
            hasError && touched,
        })}
        id={id}
        placeholder={placeholder}
        tabIndex={tabindex}
      />
      {hasError && touched && (
        <ErrorMessage errorText={errorText} />
      )}
    </>
  )
}

export default Input;
